import React from 'react';
import { ListGroup } from 'react-bootstrap';
import logo from '../../../../assets/images/IQVIA_Logo.png';
import skillLogo from '../../../../assets/images/skillinsight.svg';
import { NavLink } from 'react-router-dom';
import { getSessionStorage } from '../../../../utils/helpers';
const navItemClass = ['nav-item', 'd-flex', 'align-items-center'];

const NavLeft = () => {
  const permissionLevel = getSessionStorage('PERMISSION_LEVEL');
  const userType = getSessionStorage('USER_TYPE');
  return (
    <>
      <ListGroup as="ul" bsPrefix=" " className="navbar-nav mr-auto d-flex align-items-center">
        <ListGroup.Item as="li" bsPrefix=" " className={navItemClass.join(' ')} style={{ color: 'white' }}>
          {userType != 'External' ? (
            <NavLink to="/" className="f-w-400">
              <img src={logo} height="50px" width="130px" alt="logo" />
            </NavLink>
          ) : (
            <img src={logo} height="50px" width="130px" alt="logo" />
          )}

          <p className="skill-insight-bar" />
          {userType != 'External' ? (
            <NavLink to="/">
              <img src={skillLogo} alt="logo" className="skill-insight-logo" />
            </NavLink>
          ) : (
            <img src={skillLogo} alt="logo" className="skill-insight-logo" />
          )}

          {/* <span style={{ fontSize: 'large', marginTop: -3 }}>| Skill Insight </span> */}
        </ListGroup.Item>
      </ListGroup>
    </>
  );
};

export default NavLeft;
